var map = {
	"./GoldAlpha2x.png": 804,
	"./GoldBeta2x.png": 805,
	"./GoldChi2x.png": 806,
	"./GoldDelta2x.png": 807,
	"./GoldEpsilon2x.png": 808,
	"./GoldEta2x.png": 809,
	"./GoldGamma2x.png": 810,
	"./GoldIota2x.png": 811,
	"./GoldKappa2x.png": 812,
	"./GoldLambda2x.png": 813,
	"./GoldMu2x.png": 814,
	"./GoldNu2x.png": 815,
	"./GoldOmega2x.png": 816,
	"./GoldOmicron2x.png": 817,
	"./GoldPhi2x.png": 818,
	"./GoldPi2x.png": 819,
	"./GoldPsi2x.png": 820,
	"./GoldRho2x.png": 821,
	"./GoldSigma2x.png": 822,
	"./GoldTau2x.png": 823,
	"./GoldTheta2x.png": 824,
	"./GoldUpsilon2x.png": 825,
	"./GoldXi2x.png": 826,
	"./GoldZeta2x.png": 827
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold ^\.\/Gold.*2x\.png$
// module id = 1327
// module chunks = 0